import type { NativeWistiaPlayer } from './types';

/** For injecting the function that handles tracking on the consumer side */
export type TrackFunction = (
  eventName: string,
  properties: Record<string, unknown>
) => void;

/** Video tracking options */
export interface VideoTrackingOptions {
  /** The page module the video is rendered in */
  moduleName: string;
  /** The video's tag for tracking purposes */
  videoTag?: string;
}

export interface VideoEventTracker {
  trackVideoPlayed: (wistia?: NativeWistiaPlayer) => void;
  trackVideoPaused: (wistia?: NativeWistiaPlayer) => void;
  trackVideoCompleted: (wistia?: NativeWistiaPlayer) => void;
  trackPopoverClosed: (wistia?: NativeWistiaPlayer) => void;
}

export const createVideoEventTracker = (
  trackFunction: TrackFunction,
  trackingOptions: VideoTrackingOptions
): VideoEventTracker => {
  return {
    trackVideoPlayed: wistia => {
      trackFunction('video_played', {
        action: 'play',
        ...trackingOptions,
        ...getWistiaTrackOpts(wistia),
      });
    },
    trackVideoPaused: (wistia?: NativeWistiaPlayer) => {
      trackFunction('video_played', {
        action: 'pause',
        ...trackingOptions,
        ...getWistiaTrackOpts(wistia),
      });
    },
    trackVideoCompleted: (wistia?: NativeWistiaPlayer) => {
      trackFunction('video_completed', {
        ...trackingOptions,
        ...getWistiaTrackOpts(wistia),
      });
    },
    trackPopoverClosed: (wistia?: NativeWistiaPlayer) => {
      trackFunction('popoverhide', {
        ...trackingOptions,
        ...getWistiaTrackOpts(wistia),
      });
    },
  };
};

const getWistiaTrackOpts = (wistia?: NativeWistiaPlayer) => ({
  videoName: wistia?.name(),
  timePlayed: wistia?.time(),
});
